// Central source for system status / incident banner.
// Edit `currentIncident` to publish a notice site-wide.

export type IncidentSeverity = "info" | "maintenance" | "degraded" | "outage" | "resolved";

export interface Incident {
  id: string;
  severity: IncidentSeverity;
  title: string;
  message: string;
  startedAt: string; // ISO
  resolvedAt?: string; // ISO
  link?: string;
}

// Set to an Incident to show the banner. Leave null when all systems are operational.
export const currentIncident: Incident | null = null;

// Recent history shown on the /status page.
export const incidentHistory: Incident[] = [
  {
    id: "2026-06-10-checkout",
    severity: "resolved",
    title: "Checkout latency",
    message: "Brief slowdown in checkout sessions caused by an upstream payments provider.",
    startedAt: "2026-06-10T14:02:00Z",
    resolvedAt: "2026-06-10T14:41:00Z",
  },
];

export const systems = [
  { name: "Web app", status: "operational" as const },
  { name: "Authentication", status: "operational" as const },
  { name: "AI Coach", status: "operational" as const },
  { name: "Payments", status: "operational" as const },
  { name: "Database", status: "operational" as const },
] satisfies Array<{ name: string; status: "operational" | "degraded" | "outage" | "maintenance" }>;
